"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  quote: "Rhythm & Soul doesn't just produce tracks; they engineer sonic landscapes that define the modern era.",
  name: "Julian Vane",
  role: "Executive Producer, Sony Music"
}, {
  quote: "The precision in the mixing and the depth of the beat licensing is unmatched in the current industry.",
  name: "Aria Sterling",
  role: "Independent Artist"
}, {
  quote: "A minimalist approach that allows the raw emotion of the music to resonate with absolute clarity.",
  name: "David Kross",
  role: "Head of A&R, Def Jam"
}];
export default function ArtistFeedback() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223727" id="artist-feedback" className="bg-background text-foreground py-24 md:py-40 overflow-hidden relative" ref={ref}>
      <div className={`container mx-auto px-4 md:px-16 max-w-7xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <Carousel opts={{
        loop: true,
        align: "center"
      }} className="w-full relative">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="w-full">
                <div className="flex flex-col items-center justify-center text-center px-8 md:px-24 py-12">
                  <blockquote className="max-w-5xl mx-auto space-y-12">
                    <p className="font-serif italic text-3xl md:text-5xl lg:text-[3rem] leading-[1.1] tracking-tighter text-foreground">
                      "{testimonial.quote}"
                    </p>
                    <footer className="flex flex-col items-center justify-center gap-2 mt-12">
                      <div className="h-px w-12 bg-border mb-4" />
                      <cite className="not-italic font-mono text-xs md:text-sm uppercase tracking-[0.3em] text-muted-foreground flex flex-col md:flex-row items-center gap-2 md:gap-4">
                        <span className="text-foreground font-default font-semibold">
                          {testimonial.name}
                        </span>
                        <span className="hidden md:inline-block text-border">•</span>
                        <span>{testimonial.role}</span>
                      </cite>
                    </footer>
                  </blockquote>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="hidden md:block">
            <CarouselPrevious className="size-16 border-none bg-transparent hover:bg-transparent text-foreground hover:text-muted-foreground [&_svg]:size-12 -left-4 lg:-left-12 transition-colors" />
            <CarouselNext className="size-16 border-none bg-transparent hover:bg-transparent text-foreground hover:text-muted-foreground [&_svg]:size-12 -right-4 lg:-right-12 transition-colors" />
          </div>
          
          {}
          <div className="flex md:hidden justify-center gap-4 mt-8">
            <CarouselPrevious className="relative inset-auto translate-x-0 translate-y-0 size-12 border border-border bg-transparent hover:bg-accent text-foreground [&_svg]:size-6" />
            <CarouselNext className="relative inset-auto translate-x-0 translate-y-0 size-12 border border-border bg-transparent hover:bg-accent text-foreground [&_svg]:size-6" />
          </div>
        </Carousel>
      </div>
    </section>;
}